import io from "socket.io-client";

const init = ({ onHumeMessage }) => {
  const socketIOSocket = io(
    "https://transcription-socket-server-wispy-frog-7730.fly.dev"
  );
  //   const socketIOSocket = io("http://localhost:3002");
  socketIOSocket.on("hume message", (msg) => {
    const humeDetails = JSON.parse(msg)
      .language?.predictions[0]?.emotions.sort((a, b) => b.score - a.score)
      .slice(0, 5);
    onHumeMessage(humeDetails);
  });

  return socketIOSocket;
};

export default init;
